module.exports = __webpack_public_path__ + "static/img/14000525.0a35e92b.png";